import * as React from "react";
import TextField from "@material-ui/core/TextField"

import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import { DateRangePicker, DateRangeDelimiter, LocalizationProvider } from "@material-ui/pickers"

import moment from "moment"
import MomentUtils from "@date-io/moment"

const IntervalDatePicker = ({ value, setValue }) => {
    const locale = "fr-FR"

    const theme = createTheme({
        typography: { htmlFontSize: 10, fontFamily: 'Montserrat', fontWeight: '600' },
        overrides: {
            MuiInputBase: {
                input: {
                    borderRadius: '5px',
                    textDecoration: 'none',
                    outline: 'none',
                    // color: 'white',
                    backgroundColor: '#f0f5ff',
                    border: '1.5px solid rgba(30, 59, 161, 0.15)',
                    // textAlign: 'center',
                    fontSize: '1.4rem',
                    letterSpacing: '1.5px',
                    width: '30rem',
                    fontWeight: '500',
                    cursor: 'context-menu',
                }
            },
            MuiOutlinedInput: {
                input: {
                    padding: '1rem 2rem'
                },
                notchedOutline: { border: 'none' }
            },
            MuiPickersPopper: {
                root: {
                    zoom: '0.8',
                    transform: 'translate3d(373px, 364px, 0px)'
                }
            },
            MuiInputLabel: {
                outlined: {
                    fontFamily: 'Montserrat',
                    fontSize: '10px',
                    transform: 'translate(14px, 10px) scale(1)'
                }
            },
            MuiFormLabel: {
                root: {
                    display: 'none'
                }
            }
        }
    });

    return (
        <LocalizationProvider dateLibInstance={moment} dateAdapter={MomentUtils} locale={locale}>
            <ThemeProvider theme={theme}>
                <DateRangePicker
                    startText="Date de début"
                    endText="Date de fin"
                    inputFormat="DD/MM/YYYY"
                    value={value}
                    onChange={(newValue) => setValue(newValue)}
                    renderInput={(startProps, endProps) => (
                        <React.Fragment>
                            <TextField {...startProps} />
                            <DateRangeDelimiter> to </DateRangeDelimiter>
                            <TextField {...endProps} />
                        </React.Fragment>
                    )}
                />
            </ThemeProvider>
        </LocalizationProvider>
    );
}

export default IntervalDatePicker